import {
  IonCheckbox,
  IonInput,
  IonItem,
  IonItemGroup,
  IonLabel,
  IonRadio,
  IonRadioGroup,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Spacer from "../../../components/spacer";
import { getEntry, saveEntry } from "../../../services/users";
import EntryErrors from "./components/EntryErrors";
import FormNavigation from "./FormNavigation";

interface props {
  user: any;
  eid: any;
  dateTS: any;
  type: any;
}

const AddEditEntryToilet: React.FC<props> = ({ user, eid, dateTS, type }) => {
  const history = useHistory();

  const defaultState = {
    eid: "",
    date: "",
    dateTS: "",
    page: 0,
    complete: false,
    entryType: "",
    time: "00:00",
    approach: "",
    stage: "",
    level: "",
    trainingDay: "",
    request: "",
    walking: "",
    undressing: "",
    sitting: "",
    sittingDuration: "",
    urination: false,
    defecation: false,
    didNotVoid: false,
    wiping: "",
    dressing: "",
    flushing: "",
    overnightAccident: "",
    accidentUrination: "",
    nightNappy: "",
    accidentDefecation: "",
    numONAccidents: 0,
    ONaccidentUrination: "",
    ONaccidentDefecation: "",
  };

  const [entry, setEntry] = useState<any>(defaultState);
  const [setupComplete, setSetupComplete] = useState<any>(false);
  const [dates, setDates] = useState<any>([]);
  const [formErrors, setFormErrors] = useState<any>([]);

  const {
    date,
    page,
    complete,
    entryType,
    time,
    approach,
    stage,
    level,
    request,
    walking,
    undressing,
    sitting,
    sittingDuration,
    urination,
    defecation,
    didNotVoid,
    wiping,
    dressing,
    flushing,
    overnightAccident,
    accidentUrination,
    accidentDefecation,
    nightNappy,
    numONAccidents,
    ONaccidentUrination,
    ONaccidentDefecation,
  } = entry;

  const _onChange = (e: any) => {
    if (setupComplete) {
      let name = e.target.name;
      let value = e.target.value;

      //console.log(name);

      if (name === "defecation" && !defecation) {
        setEntry({ ...entry, defecation: false, wiping: "" });
      } else if (name === "overnightAccident" && value === "dry") {
        setEntry({
          ...entry,
          overnightAccident: "dry",
          numONAccidents: 0,
          ONaccidentUrination: false,
          ONaccidentDefecation: false,
          nightNappy: "",
        });
      } else if (name === "overnightAccident" && value === "nappy") {
        setEntry({
          ...entry,
          overnightAccident: "nappy",
          numONAccidents: 0,
          ONaccidentUrination: false,
          ONaccidentDefecation: false,
        });
      } else if (name === "overnightAccident" && value === "accident") {
        setEntry({
          ...entry,
          overnightAccident: "accident",
          nightNappy: "",
        });
      } else {
        setEntry({ ...entry, [name]: value });
      }
    }
  };

  const _onSubmit = () => {
    let stepValid = _checkValid(page);

    if (stepValid) {
      _saveEntry({ ...entry, complete: true });
      history.push(`/users/${user.id}`);
    }
  };

  const _saveEntry = (data: any) => {
    saveEntry(user.id, data);
  };

  // useEffect(() => {
  // 	if (entry) {
  // 		console.log(entry);
  // 	}
  // }, [entry]);

  useEffect(() => {
    if (!user.id && user.uid) user.id = user.uid;
    if (user && user.id) {
      if (eid && eid !== "new") {
        getEntry(user.id, eid).then((doc) => {
          setEntry({ ...defaultState, ...doc });
          setSetupComplete(true);
        });
      }
      if (user.dates && Object.values(dates).length < 1) {
        getUserDates();
      }
    }
  }, [user, eid]);

  useEffect(() => {
    //console.log(dates);
    //console.log(dateTS);
    if (dates && dateTS && entry.date === "") {
      let today = new Date().getTime();
      let conditional = {};
      if (type === "regular") {
        conditional = { urination: false, defecation: false };
      } else if (type === "accident") {
        conditional = { accidentUrination: false, accidentDefecation: false };
      } else if (type === "overnight") {
        conditional = {
          ONaccidentUrination: false,
          ONaccidentDefecation: false,
        };
      }
      setEntry({
        ...entry,
        eid: today.toString(),
        entryType: type,
        dateTS,
        date: getDate(),
        ...conditional,
      });
      setSetupComplete(true);
    }
  }, [dates]);

  /**
   * Create an array of objects which represent dates within phases and whether an entry is required
   */
  const getUserDates = () => {
    //console.log("triggered");
    let response: any = [];
    let today = new Date().getTime();

    Object.values(user.dates).forEach((element: any) => {
      let status = "upcoming";
      let link = "upcoming";
      let date = element.timestamp;

      //Add another condition here to check if an entry exists for the date and add a link
      if (date <= today) {
        status = "overdue";
        link = "new";
      }

      response[date] = {
        ...element,
        status,
        link,
      };
    });
    setDates(response);
  };

  const getDate = () => {
    let res = "";
    if (dates[dateTS]) {
      let date = dates[dateTS];
      res = date.dateField;
    }
    return res;
  };

  const _checkValid = (page: any) => {
    let errors: any = [];
    if (time === "" && entryType !== "overnight") {
      errors.push("Please enter a time for this entry");
    }

    if (entryType === "regular") {
      if (
        approach === "" &&
        dates[entry.dateTS].pType !== "baseline" &&
        dates[entry.dateTS].pType !== "initial"
      ) {
        errors.push("You must select the approach you are using");
      }
      if (approach === "gradual" && stage === "") {
        errors.push("You must select the stage you are at");
      }
      if (approach === "intensive" && level === "") {
        errors.push("You must indicate current level");
      }
      // if (approach === "intensive" && trainingDay === "") {
      // 	errors.push("You must indicate current training day");
      // }
      if (request === "") {
        errors.push("Please answer all questions");
      }
      if (walking === "") {
        errors.push("Please answer all questions");
      }
      if (undressing === "") {
        errors.push("Please answer all questions");
      }
      if (sitting === "") {
        errors.push("Please answer all questions");
      }
      if (sittingDuration === "") {
        errors.push("Please answer all questions");
      }
      if (defecation && wiping === "") {
        errors.push("Please answer all questions");
      }
      if (dressing === "") {
        errors.push("Please answer all questions");
      }
      if (flushing === "") {
        errors.push("Please answer all questions");
      }
    } else if (entryType === "accident") {
      if (!accidentUrination && !accidentDefecation) {
        errors.push("You must indicate the type of accident");
      }
    } else if (entryType === "overnight") {
      if (overnightAccident === "") {
        errors.push("You must indicate if there was an overnight accident");
      }
      if (
        overnightAccident === "accident" &&
        !ONaccidentUrination &&
        !ONaccidentDefecation
      ) {
        errors.push("You must indicate the type of accident");
      }
      if (overnightAccident === "nappy" && !nightNappy) {
        errors.push("You must indicate the type of accident");
      }
    }

    setFormErrors(errors);

    return Object.values(errors).length === 0;
  };

  const changePage = (toPage: any) => {
    if (toPage > page) {
      let stepValid = _checkValid(page);

      if (stepValid) {
        setEntry({ ...entry, page: toPage });
        _saveEntry({ ...entry, page: toPage });
      }
    } else {
      setFormErrors([]);
      setEntry({ ...entry, page: toPage });
      //_saveEntry({ ...entry, page: toPage });
    }
  };

  const _onSelect = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    // let id = e.target.dataset.id;

    if (name === "approach") {
      //console.log("approach");
      if (value === "gradual") {
        setEntry({
          ...entry,
          approach: "gradual",
          level: "",
          trainingDay: "",
        });
      } else {
        setEntry({ ...entry, approach: "intensive", stage: "" });
      }
    } else if (name === "level") {
      setEntry({ ...entry, level: value });
    }
  };

  const _compareApproach = (o1: any, o2: any) => {
    return o1 === approach;
  };
  const _compareLevel = (o1: any, o2: any) => {
    return o1 === level;
  };

  const _onCheckBoxClick = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    // console.log(name, value, entry[name]);

    if (entry[name] !== (value === "on")) {
      if (name === "defecation" && defecation === true) {
        setEntry({ ...entry, defecation: !defecation, wiping: "" });
      } else if (name === "didNotVoid" && didNotVoid === false) {
        setEntry({
          ...entry,
          didNotVoid: true,
          urination: false,
          defecation: false,
          wiping: "",
        });
      } else {
        setEntry({ ...entry, [name]: !entry[name], didNotVoid: false });
      }
    }
  };

  return (
    <div className="content-wrapper">
      <Spacer size="60" />
      {setupComplete && (
        <>
          {entryType === "overnight" && <h1>Overnight report</h1>}
          {entryType === "accident" && (
            <h1>Accident details (including in nappy)</h1>
          )}
          {entryType === "regular" && <h1>Log entry details</h1>}

          {dateTS && dates && dates[dateTS] && <>{dates[dateTS].dateString}</>}
          {!dateTS && dates && dates[entry.dateTS] && (
            <>{dates[entry.dateTS].dateString}</>
          )}
          <Spacer size="30" />

          {dateTS && user.dates && (
            <IonInput
              name="date"
              value={date}
              type="date"
              hidden
              onIonChange={_onChange}
            />
          )}
          <FormNavigation
            page={page}
            setPage={changePage}
            onSubmit={_onSubmit}
            numPages={1}
          />
          <EntryErrors errors={formErrors} />
          <Spacer size="60" />
          {page === 0 && (
            <>
              <IonItemGroup>
                {entryType !== "overnight" && (
                  <IonItem lines="none">
                    {entryType === "accident" && (
                      <IonLabel position="stacked">Time of accident</IonLabel>
                    )}
                    {entryType === "regular" && (
                      <IonLabel position="stacked">Time of toileting</IonLabel>
                    )}
                    <IonInput
                      name="time"
                      value={time}
                      type="time"
                      // hidden
                      onIonChange={_onChange}
                    />
                  </IonItem>
                )}

                <Spacer size="30" />
                {entryType === "overnight" && (
                  <>
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        Overnight Accident?
                      </IonLabel>
                      <Spacer size="10" />
                      <IonRadioGroup
                        id="overnightAccident"
                        name="overnightAccident"
                        value={overnightAccident}
                        onIonChange={_onChange}
                      >
                        <IonItem lines="none">
                          <IonLabel>Dry</IonLabel>
                          <IonRadio slot="start" value="dry"></IonRadio>
                        </IonItem>
                        <IonItem lines="none">
                          <IonLabel>Accident</IonLabel>
                          <IonRadio slot="start" value="accident"></IonRadio>
                        </IonItem>
                        <IonItem lines="none">
                          <IonLabel>Night Nappy</IonLabel>
                          <IonRadio slot="start" value="nappy"></IonRadio>
                        </IonItem>
                      </IonRadioGroup>
                    </IonItem>
                    <Spacer size="30" />
                    {overnightAccident === "accident" && (
                      <>
                        <IonItem>
                          <IonLabel position="stacked">
                            Number of Overnight Accidents
                          </IonLabel>
                          <IonInput
                            type="number"
                            id="numONAccidents"
                            name="numONAccidents"
                            value={numONAccidents}
                            onIonChange={_onChange}
                          />
                        </IonItem>
                        <Spacer size="30" />
                        <IonItem lines="none">
                          <IonLabel position="stacked">
                            Urination or Defecation?
                          </IonLabel>
                          <Spacer size="10" />

                          <IonItem lines="none">
                            <IonLabel>Urination</IonLabel>
                            <IonCheckbox
                              id="ONaccidentUrination"
                              name="ONaccidentUrination"
                              checked={ONaccidentUrination}
                              onIonChange={_onCheckBoxClick}
                              slot="start"
                            />
                          </IonItem>
                          <IonItem lines="none">
                            <IonLabel>Defecation</IonLabel>
                            <IonCheckbox
                              id="ONaccidentDefecation"
                              name="ONaccidentDefecation"
                              checked={ONaccidentDefecation}
                              onIonChange={_onCheckBoxClick}
                              slot="start"
                            />
                          </IonItem>
                        </IonItem>
                      </>
                    )}
                    {overnightAccident === "nappy" && (
                      <>
                        <IonItem lines="none">
                          <IonLabel position="stacked">
                            In the morning the nappy was?
                          </IonLabel>
                          <Spacer size="10" />
                          <IonRadioGroup
                            id="nightNappy"
                            name="nightNappy"
                            value={nightNappy}
                            onIonChange={_onChange}
                          >
                            <IonItem lines="none">
                              <IonLabel>Wet</IonLabel>
                              <IonRadio slot="start" value="wet"></IonRadio>
                            </IonItem>
                            <IonItem lines="none">
                              <IonLabel>Dry</IonLabel>
                              <IonRadio slot="start" value="dry"></IonRadio>
                            </IonItem>
                          </IonRadioGroup>
                        </IonItem>
                      </>
                    )}
                  </>
                )}
                {entryType === "accident" && (
                  <>
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        Urination or Defecation?
                      </IonLabel>
                      <Spacer size="10" />

                      <IonItem lines="none">
                        <IonLabel>Urination</IonLabel>
                        <IonCheckbox
                          id="accidentUrination"
                          name="accidentUrination"
                          checked={accidentUrination}
                          onIonChange={_onCheckBoxClick}
                          slot="start"
                        />
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>Defecation</IonLabel>
                        <IonCheckbox
                          id="accidentDefecation"
                          name="accidentDefecation"
                          checked={accidentDefecation}
                          onIonChange={_onCheckBoxClick}
                          slot="start"
                        />
                      </IonItem>
                    </IonItem>
                  </>
                )}

                {entryType === "regular" && (
                  <>
                    {dates[entry.dateTS].pType !== "baseline" &&
                      dates[entry.dateTS].pType !== "initial" && (
                        <IonItem lines="none">
                          <IonLabel position="stacked">Approach</IonLabel>
                          <IonSelect
                            compareWith={_compareApproach}
                            id="approach"
                            name="approach"
                            value={approach}
                            onIonChange={_onSelect}
                            okText="Okay"
                            cancelText="Dismiss"
                            placeholder="Select One"
                          >
                            <IonSelectOption value="gradual">
                              Gradual
                            </IonSelectOption>
                            <IonSelectOption value="intensive">
                              Intensive
                            </IonSelectOption>
                          </IonSelect>
                        </IonItem>
                      )}
                    <Spacer size="30" />
                    {approach === "gradual" && (
                      <>
                        <IonItem lines="none">
                          <IonLabel position="stacked">Stage</IonLabel>
                          <Spacer size="10" />
                          <IonRadioGroup
                            id="stage"
                            name="stage"
                            value={stage}
                            onIonChange={_onChange}
                          >
                            <IonItem lines="none">
                              <IonLabel>Stage 1: Sitting dressed</IonLabel>
                              <IonRadio slot="start" value="1"></IonRadio>
                            </IonItem>
                            <IonItem lines="none">
                              <IonLabel>
                                Stage 2: Sitting during nappy-change
                              </IonLabel>
                              <IonRadio slot="start" value="2"></IonRadio>
                            </IonItem>
                            <IonItem lines="none">
                              <IonLabel>
                                Stage 3: Sitting a few times per day
                              </IonLabel>
                              <IonRadio slot="start" value="3"></IonRadio>
                            </IonItem>
                            <IonItem lines="none">
                              <IonLabel>
                                Stage 4: Established toileting routine
                              </IonLabel>
                              <IonRadio slot="start" value="4"></IonRadio>
                            </IonItem>
                          </IonRadioGroup>
                        </IonItem>
                        <Spacer size="30" />
                      </>
                    )}
                    {approach === "intensive" && (
                      <>
                        {/* <IonItem>
													<IonLabel position="stacked">Level</IonLabel>
													<IonInput
														type="number"
														id="level"
														name="level"
														value={level}
														onIonChange={_onChange}
													/>
												</IonItem> */}
                        <IonItem lines="none">
                          <IonSelect
                            compareWith={_compareLevel}
                            id="level"
                            name="level"
                            value={level}
                            onIonChange={_onSelect}
                            okText="Okay"
                            cancelText="Dismiss"
                            placeholder="Select One"
                          >
                            <IonSelectOption value="1">1</IonSelectOption>
                            <IonSelectOption value="2">2</IonSelectOption>
                            <IonSelectOption value="3">3</IonSelectOption>
                            <IonSelectOption value="4">4</IonSelectOption>
                            <IonSelectOption value="5">5</IonSelectOption>
                            <IonSelectOption value="6">6</IonSelectOption>
                            <IonSelectOption value="7">7</IonSelectOption>
                            <IonSelectOption value="8">8</IonSelectOption>
                            <IonSelectOption value="9">9</IonSelectOption>
                            <IonSelectOption value="10">10</IonSelectOption>
                            <IonSelectOption value="11">11</IonSelectOption>
                            <IonSelectOption value="12">12</IonSelectOption>
                          </IonSelect>
                        </IonItem>

                        <Spacer size="30" />
                        {/* <IonItem>
													<IonLabel position="stacked">Training Day</IonLabel>
													<IonInput
														type="number"
														id="trainingDay"
														name="trainingDay"
														value={trainingDay}
														onIonChange={_onChange}
													/>
												</IonItem>
												<Spacer size="30" /> */}
                      </>
                    )}
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        Requested to use toilet
                      </IonLabel>
                      <Spacer size="10" />
                      <IonRadioGroup
                        id="request"
                        name="request"
                        value={request}
                        onIonChange={_onChange}
                      >
                        <IonItem lines="none">
                          <IonLabel>Independent</IonLabel>
                          <IonRadio slot="start" value="independent"></IonRadio>
                        </IonItem>
                        <IonItem lines="none">
                          <IonLabel>Prompted</IonLabel>
                          <IonRadio slot="start" value="prompted"></IonRadio>
                        </IonItem>
                      </IonRadioGroup>
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        Walking to the toilet
                      </IonLabel>
                      <Spacer size="10" />
                      <IonRadioGroup
                        id="walking"
                        name="walking"
                        value={walking}
                        onIonChange={_onChange}
                      >
                        <IonItem lines="none">
                          <IonLabel>Independent</IonLabel>
                          <IonRadio slot="start" value="independent"></IonRadio>
                        </IonItem>
                        <IonItem lines="none">
                          <IonLabel>Prompted</IonLabel>
                          <IonRadio slot="start" value="prompted"></IonRadio>
                        </IonItem>
                      </IonRadioGroup>
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">Undressing</IonLabel>
                      <Spacer size="10" />
                      <IonRadioGroup
                        id="undressing"
                        name="undressing"
                        value={undressing}
                        onIonChange={_onChange}
                      >
                        <IonItem lines="none">
                          <IonLabel>Independent</IonLabel>
                          <IonRadio slot="start" value="independent"></IonRadio>
                        </IonItem>
                        <IonItem lines="none">
                          <IonLabel>Prompted</IonLabel>
                          <IonRadio slot="start" value="prompted"></IonRadio>
                        </IonItem>
                      </IonRadioGroup>
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">
                        Sitting on the toilet
                      </IonLabel>
                      <Spacer size="10" />
                      <IonRadioGroup
                        id="sitting"
                        name="sitting"
                        value={sitting}
                        onIonChange={_onChange}
                      >
                        <IonItem lines="none">
                          <IonLabel>Independent</IonLabel>
                          <IonRadio slot="start" value="independent"></IonRadio>
                        </IonItem>
                        <IonItem lines="none">
                          <IonLabel>Prompted</IonLabel>
                          <IonRadio slot="start" value="prompted"></IonRadio>
                        </IonItem>
                      </IonRadioGroup>
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem>
                      <IonLabel position="stacked">
                        Duration of toilet sit in minutes
                      </IonLabel>
                      <IonInput
                        type="number"
                        id="sittingDuration"
                        name="sittingDuration"
                        value={sittingDuration}
                        onIonChange={_onChange}
                      />
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">Use of the toilet?</IonLabel>
                      <Spacer size="10" />

                      <IonItem lines="none">
                        <IonLabel>Urination</IonLabel>
                        <IonCheckbox
                          id="urination"
                          name="urination"
                          checked={urination}
                          onIonChange={_onCheckBoxClick}
                          slot="start"
                        />
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>Defecation</IonLabel>
                        <IonCheckbox
                          id="defecation"
                          name="defecation"
                          checked={defecation}
                          onIonChange={_onCheckBoxClick}
                          slot="start"
                        />
                      </IonItem>
                      <IonItem lines="none">
                        <IonLabel>Did not void</IonLabel>
                        <IonCheckbox
                          id="didNotVoid"
                          name="didNotVoid"
                          checked={didNotVoid}
                          onIonChange={_onCheckBoxClick}
                          slot="start"
                        />
                      </IonItem>
                    </IonItem>
                    <Spacer size="30" />
                    {defecation && (
                      <>
                        <IonItem lines="none">
                          <IonLabel position="stacked">Wiping</IonLabel>
                          <Spacer size="10" />
                          <IonRadioGroup
                            id="wiping"
                            name="wiping"
                            value={wiping}
                            onIonChange={_onChange}
                          >
                            {/* <IonItem lines="none">
															<IonLabel>N/A</IonLabel>
															<IonRadio slot="start" value="NA"></IonRadio>
														</IonItem> */}
                            <IonItem lines="none">
                              <IonLabel>Independent</IonLabel>
                              <IonRadio
                                slot="start"
                                value="independent"
                              ></IonRadio>
                            </IonItem>
                            <IonItem lines="none">
                              <IonLabel>Prompted</IonLabel>
                              <IonRadio
                                slot="start"
                                value="prompted"
                              ></IonRadio>
                            </IonItem>
                          </IonRadioGroup>
                        </IonItem>
                        <Spacer size="30" />
                      </>
                    )}
                    <IonItem lines="none">
                      <IonLabel position="stacked">Dressing</IonLabel>
                      <Spacer size="10" />
                      <IonRadioGroup
                        id="dressing"
                        name="dressing"
                        value={dressing}
                        onIonChange={_onChange}
                      >
                        <IonItem lines="none">
                          <IonLabel>Independent</IonLabel>
                          <IonRadio slot="start" value="independent"></IonRadio>
                        </IonItem>
                        <IonItem lines="none">
                          <IonLabel>Prompted</IonLabel>
                          <IonRadio slot="start" value="prompted"></IonRadio>
                        </IonItem>
                      </IonRadioGroup>
                    </IonItem>
                    <Spacer size="30" />
                    <IonItem lines="none">
                      <IonLabel position="stacked">Flushing</IonLabel>
                      <Spacer size="10" />
                      <IonRadioGroup
                        id="flushing"
                        name="flushing"
                        value={flushing}
                        onIonChange={_onChange}
                      >
                        <IonItem lines="none">
                          <IonLabel>Independent</IonLabel>
                          <IonRadio slot="start" value="independent"></IonRadio>
                        </IonItem>
                        <IonItem lines="none">
                          <IonLabel>Prompted</IonLabel>
                          <IonRadio slot="start" value="prompted"></IonRadio>
                        </IonItem>
                      </IonRadioGroup>
                    </IonItem>
                  </>
                )}
              </IonItemGroup>
            </>
          )}
          <Spacer size="60" />
          <EntryErrors errors={formErrors} />
          <FormNavigation
            page={page}
            setPage={changePage}
            onSubmit={_onSubmit}
            numPages={1}
          />
        </>
      )}
    </div>
  );
};

export default AddEditEntryToilet;
